import dayjs from 'dayjs';

export const getDateRange = (period: string) => {
  const today = dayjs();
  
  switch (period) {
    case 'today':
      return {
        startDate: today.format('YYYY-MM-DD'),
        endDate: today.format('YYYY-MM-DD')
      };
    case 'yesterday':
      const yesterday = today.subtract(1, 'day');
      return {
        startDate: yesterday.format('YYYY-MM-DD'),
        endDate: yesterday.format('YYYY-MM-DD')
      };
    case 'last-7-days':
      return {
        startDate: today.subtract(7, 'day').format('YYYY-MM-DD'),
        endDate: today.format('YYYY-MM-DD')
      };
    case 'last-30-days':
      return {
        startDate: today.subtract(30, 'day').format('YYYY-MM-DD'),
        endDate: today.format('YYYY-MM-DD')
      };
    case 'last-60-days':
      return {
        startDate: today.subtract(60, 'day').format('YYYY-MM-DD'),
        endDate: today.format('YYYY-MM-DD')
      };
    case 'last-90-days':
      return {
        startDate: today.subtract(90, 'day').format('YYYY-MM-DD'),
        endDate: today.format('YYYY-MM-DD')
      };
    case 'last-6-months':
      return {
        startDate: today.subtract(6, 'month').format('YYYY-MM-DD'),
        endDate: today.format('YYYY-MM-DD')
      };
    case 'last-1-year':
      return {
        startDate: today.subtract(1, 'year').format('YYYY-MM-DD'),
        endDate: today.format('YYYY-MM-DD')
      };
    default:
      return {
        startDate: today.format('YYYY-MM-DD'),
        endDate: today.format('YYYY-MM-DD')
      };
  }
};

export const DATE_RANGE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last-7-days', label: 'Last 7 Days' },
  { value: 'last-30-days', label: 'Last 30 Days' },
  { value: 'last-60-days', label: 'Last 60 Days' },
  { value: 'last-90-days', label: 'Last 90 Days' },
  { value: 'last-6-months', label: 'Last 6 Months' },
  { value: 'last-1-year', label: 'Last 1 Year' }
];
